(function(angular){
	'use strict';

	angular
		.module('educationSiteModule')
		.controller('FAQController', [
			'$location',
			'$timeout',
			'$window',
			'globalConfig',
			'mixpanelFactory',
			'smoothScroll',
			FAQControllerFunction
		]);

	function FAQControllerFunction(
		$location,
		$timeout,
		$window,
		globalConfig,
		mixpanelFactory,
		smoothScroll
	){
		var faq = this;

		function checkUrlHash() {
			var hashId = $location.hash();

			if(hashId.indexOf('item') >= 0) {
				var item = openFaqItem(hashId);

				$timeout(function() {
					if(angular.isDefined(item)) {
						trackOpenQuestion(item);
						faq.scrollTo('item' + item.faqId + '-question');
					}
				});
			}
		}

		function openFaqItem(faqId) {
			var openedItem;

			angular.forEach(faq.faqCategories, function(category) {
				angular.forEach(category.items, function(item) {
					if('item' + item.faqId === faqId) {
						item.opened = true;
						openedItem = item;
					}
				});
			});

			return openedItem;
		}

		function trackCloseQuestion(item) {
			mixpanelFactory.track('FAQ Closed', {
				'Question': '#item' + item.faqId,
				'Question Text': item.question
			});
		}

		function trackOpenQuestion(item) {
			mixpanelFactory.track('FAQ Opened', {
				'Question': '#item' + item.faqId,
				'Question Text': item.question
			});
		}

		faq.FAQClick = function(item) {
			$location.hash('item' + item.faqId);
			item.opened = !item.opened;
			
			if(item.opened) {
				trackOpenQuestion(item);
			} else {
				trackCloseQuestion(item);
			}
		};

		faq.scrollTo = function(elementId) {
			var element = angular.element($window.document.getElementById(elementId));

			smoothScroll(element[0], {
				duration: 400,
				offset: 70
			});
		};

		faq.$onInit = function() {
			angular.extend(faq, globalConfig);
			checkUrlHash();
			mixpanelFactory.track('FAQ viewed');
		};
	}
})(window.angular);